<script>
import RangeSlider from './RangeSlider';

export default {
  name: 'PredictorSlider',
  components: {
    RangeSlider,
  },
  props: {
    sliderIcon: {
      type: String,
      required: true,
    },
    sliderValue: {
      type: Number,
      required: true,
    },
    sliderLabel: {
      type: String,
      required: true,
    },
    sliderKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentSliderValue: 0,
      defaultValue: 0,
    };
  },
  watch: {
    sliderValue(value) {
      this.currentSliderValue = value;
    },
  },
  beforeMount() {
    this.currentSliderValue = this.sliderValue;
    this.defaultValue = this.sliderValue;
  },
};
</script>

<template>
  <div class="predictor-slider">
    <div class="predictor-slider__header">
      <img :src="sliderIcon" :alt="sliderLabel" class="predictor-slider__icon" >
      <div class="predictor-label">{{ sliderLabel }}</div>
    </div>
    <RangeSlider :slider-value="currentSliderValue" :slider-label="sliderLabel" :slider-key="sliderKey" />
  </div>
</template>
